import { segmentTrackAction } from 'lib/segment'
import { EVENT } from 'lib/segment/const'
import StateStorage from 'lib/state-storage'
import ShopLanguageMap from 'lib/i18n/shop-language-map'

const shop = StateStorage.getShop()
const user = StateStorage.getAuthUser()
const id_shop = ShopLanguageMap.getIdShopBySlug(shop)
const id_customer = user?.id_customer

const pdpSessionEvent = ({ id_product, duration, ref_id, ref_type }) => {
  const data = {
    id_shop,
    id_customer,
    id_product,
    ref_id,
    ref_type: ref_type || 'external',
    duration,
  }
  segmentTrackAction(EVENT.productSessionEvent, data)
}

export default pdpSessionEvent
